import { Rect, Text } from "react-konva";

import { COLOR_NEUTRALS_300, WORDOPOLIS_CELL_STROKE } from "../../../constants";

export interface CellProps {
  row: number;
  cell: number;
  size: number;
  content: string;
  fontColor: string;
  onClick: () => void;
}

export const Cell = (props: CellProps) => {
  const { row, cell, size, content, fontColor, onClick } = props;

  const clikcEvents = {
    onClick: () => {
      onClick();
    },
    onTap: onClick,
  };

  const cellPositionX = cell * size;
  const cellPositionY = row * size;

  return (
    <>
      <Rect
        x={cellPositionX}
        y={cellPositionY}
        width={size}
        height={size}
        strokeWidth={WORDOPOLIS_CELL_STROKE}
        stroke={COLOR_NEUTRALS_300}
        {...clikcEvents}
      />
      <Text
        x={cellPositionX + size / 4}
        y={cellPositionY + size / 3.6}
        text={content}
        fontSize={size / 2}
        fill={fontColor}
        width={size / 2}
        height={size / 2}
        align="center"
        fontStyle="bold"
        verticalAlign="middle"
        {...clikcEvents}
      />
    </>
  );
};
